var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.init)?_c('page',{attrs:{"flex-container":true,"custom-style":{
    height: '100vh'
  }}},[_c('div',{staticClass:"integral-container"},[_c('integral-detail'),_c('record')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }